module.exports = __webpack_public_path__ + "static/media/cbd3b4fb8ef7465883be78c48eff1f63@2x.b56fbb8f.png";